
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {devreKesiciSifirla} from '@/plugins/uyap-plugin/BaglantiKurtarma';

/**
 * 401 devre kesici açıldığında gösterilir. Görsel dil vue-imza-app'teki
 * OturumLimitiDialog ile aynı; ton kritik (kırmızı) çünkü burada işlem
 * kullanıcı müdahalesi olmadan devam etmiyor.
 *
 * Kesici yalnızca buradan sıfırlanır: kullanıcı bilinçli olarak "Yeniden başlat"
 * demeden sayaç temizlenirse aynı storm sessizce tekrar başlayabilir.
 */
@Component({})
export default class DevreKesiciDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly value!: boolean;

  deneniyor = false;

  get acik(): boolean {
    return this.value;
  }

  set acik(v: boolean) {
    if (!v) this.kapat();
  }

  kapat() {
    this.$emit('input', false);
  }

  async yenidenBaslat() {
    this.deneniyor = true;
    try {
      devreKesiciSifirla();
      // Bot kimliksiz giriş yapmaz: önce kimlik imzacıya devredilir, sonra giriş istenir.
      await this.$store.dispatch('kimlikDevret', {neden: 'kullanici'});
      this.$socket.client.emit('connectToUyap');
    } catch (e) {
      console.error('Yeniden başlatma denemesi başarısız.', e);
    } finally {
      this.deneniyor = false;
      this.kapat();
    }
  }
}
